<template>
  <div id="contact">
    <section style="text-align: center">
      <div class="info-container">
        <h1>Contact Us</h1>
        <form 
          action="https://liveformhq.com/form/e6df6776-07d1-4c52-8ba5-4feb8c5ee1b6" 
          method="POST" 
          accept-charset="utf-8"
          :class="{submitted: this.submitted}">
          <div class="form-container">
            <div class="input-container form-el form-size-50">
              <label for="First name">First Name *</label>
              <input 
                type="text" 
                name="First name" 
                maxlength="255" 
                required="required" 
                aria-required="true">
            </div>

            <div class="input-container form-el form-size-50">
              <label for="Last name">Last Name *</label>
              <input 
                type="text" 
                name="Last name" 
                maxlength="255" 
                required="required" 
                aria-required="true">
            </div>

            <div class="input-container form-el form-size-50">
              <label for="Email">Email *</label>
              <input 
                type="email" 
                name="Email" 
                maxlength="255" 
                required="required" 
                aria-required="true">
            </div>

            <div class="input-container form-el form-size-50">
              <label for="Phone">Phone</label>
              <input 
                type="phone" 
                name="Phone" 
                maxlength="255">
            </div>

            <div class="input-container form-el form-size-100">
              <label for="Message">Message *</label>
              <textarea 
                name="Message" 
                rows="12" cols="60" 
                required="required" 
                aria-required="true"></textarea>
            </div>

            <div class="input-container form-el form-size-100">
              <label for="Donor">Interested in being a donor?</label>
              <select 
                name="Donor">
                <option value="No" selected="selected">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>

            <div id="hasRecaptcha1" ref="cap" class="g-recaptcha input-container form-el form-size-100" data-sitekey="6Ld4srUUAAAAAJfZ5s3b4s092MPBGTa9skp_sFHq"></div>

            <input type="submit" name="Submit" value="Send Message" @click="submitted = true">
          </div>
        </form>
      </div>
    </section>
  </div>
</template>


<script>
export default {
  data () {
    return {
      submitted: false,
      recaptchRenderLimit: 0,
    }
  },
  computed: {
    currentHost() {
      return window.location.host;
    }
  },
  methods: {
    recaptchaOnload() {
      this.recaptchRenderLimit++;
      if (this.recaptchRenderLimit > 9) {
        return;
      }

      if (this.$refs.cap) {
        grecaptcha.render("hasRecaptcha1", {
            sitekey: '6Ld4srUUAAAAAJfZ5s3b4s092MPBGTa9skp_sFHq',
            callback: function() {
                console.log('recaptcha callback');
            }
        });
        return;
      }

      window.setTimeout(this.recaptchaOnload, 1000);
    }
  },
  created() {
    this.recaptchaOnload();
  }
}
</script>


